<template>
  <ul
    class="scenario-elements d-flex flex-wrap justify-content-start w-100 pl-0 mb-0"
  >
    <li>
      <img alt="language" src="../assets/language.svg" />
      <span class="element-label">{{ languageName }}</span>
    </li>
    <li v-if="!isCtgi">
      <img alt="time" src="../assets/timer.svg" />
      <span class="element-label">{{ prettyTime }}</span>
    </li>
    <li v-if="!isCtgi">
      <img alt="number of checklist items" src="../assets/tick.svg" />
      <span class="element-label">{{ numChecklistItems }} Checklist Items</span>
    </li>
    <li v-if="!isCtgi">
      <img alt="number of events" src="../assets/calendar.svg" />
      <span v-text="numEvents + ' events'" class="element-label"></span>
    </li>
    <li v-if="hasMedia">
      <i class="material-icons text-secondary">perm_media</i>
      <span class="element-label">Media</span>
    </li>
    <li v-if="hasSounds">
      <i class="material-icons text-secondary">volume_up</i>
      <span class="element-label">Sounds</span>
    </li>
    <li v-if="hasLabs">
      <img alt="has labs" src="../assets/labs.svg" />
      <span class="element-label">Labs</span>
    </li>
  </ul>
</template>

<script>
import { isoLanguages } from "@/utils/language.helper";

export default {
  name: "ScenarioElements",
  data: function() {
    return {
      prettyTime: "aa",
      languageName: "",
      isoLangs: isoLanguages,
    };
  },
  props: {
    language: String,
    durationInSeconds: Number,
    numChecklistItems: Number,
    numEvents: Number,
    hasMedia: Boolean,
    hasSounds: Boolean,
    hasLabs: Boolean,
    isCtgi: Boolean,
  },
  methods: {
    secondsToPrettyTime(seconds) {
      if (seconds === 0) return "No Time Limit";
      let m = Math.floor(seconds / 60);
      let s = seconds % 60;
      let str = "";
      if (m) {
        str = str + m + " minutes";
      }
      if (s) {
        str = str + (m > 0 ? " " : "") + s + " seconds";
      }
      return str;
    },
    getCountryName(languageCode) {
      if (this.isoLangs.hasOwnProperty(languageCode)) {
        return this.isoLangs[languageCode].name;
      } else {
        return this.languageName;
      }
    },
    formatProperties() {
      this.prettyTime = this.secondsToPrettyTime(this.durationInSeconds);
      this.languageName = this.getCountryName(this.$props.language);
    },
  },
  mounted() {
    this.formatProperties();
  },
  updated() {
    this.formatProperties();
  },
};
</script>

<style scoped>
.lighter-icon {
  color: var(--isim-light-icon);
  padding-right: 4px;
}

ul.scenario-elements {
  display: flex;
  flex-direction: row;
}

ul.scenario-elements li {
  display: flex;
  align-items: center;
  margin-right: 1rem;
}

ul.scenario-elements li:last-of-type {
  margin-right: 0;
}

ul.scenario-elements li img {
  padding-right: 6px;
  width: 24px;
  height: 24px;
}

.element-label {
  white-space: nowrap;
}
</style>
